export const WORK_MODE_OPTIONS = [
  { label: 'Onsite', value: 'onsite' },
  { label: 'Remote', value: 'remote' },
  { label: 'Hybrid', value: 'hybrid' },
];

export type WorkMode = 'onsite' | 'remote' | 'hybrid';

/**
 * Older assessment payloads may use `on_site`. Keep those records selectable
 * while sending the API's current `onsite` value for new and edited records.
 */
export const normalizeWorkMode = (value?: string | null): string => {
  if (!value) return '';
  return value.trim().toLowerCase() === 'on_site'
    ? 'onsite'
    : value.trim().toLowerCase();
};

/** Onsite and hybrid roles need a physical job location; remote roles do not. */
export const shouldCollectJobLocation = (workMode?: string | null): boolean => {
  const normalized = normalizeWorkMode(workMode);
  return normalized === 'onsite' || normalized === 'hybrid';
};

export const formatWorkMode = (value?: string | null): string => {
  const normalized = normalizeWorkMode(value);
  return WORK_MODE_OPTIONS.find((option) => option.value === normalized)?.label
    ?? (normalized ? normalized.replace(/_/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase()) : '');
};
